import 'flickity/dist/flickity.pkgd';
var Flickity = require('flickity');
import 'videojs-youtube/dist/Youtube';
import 'enllax/dist/jquery.enllax.min.js';

export default {
  init() {
    $('.wordslider').width($('.wordslider__first-word').width());

    //ENLLAX
    $(window).enllax();

    // HAMBURGER
    $('.hamburger').click(function() {
      $(this).toggleClass('active');
      $('body').toggleClass('hamburger-active');
    });

    $('.hamburger-bg').click(function() {
      $('.hamburger').toggleClass('active');
      $('body').toggleClass('hamburger-active');
    });

    // HAMBURGER
    $('.mobile-nav ul li.menu-item-has-children').click(function() {
      if ($(this).hasClass('active')) {
        $(this).removeClass('active');
      } else {
        $('.mobile-nav ul li.menu-item-has-children').removeClass('active');
        $(this).addClass('active');
      }
    });

    // SCROLLED
    $(window).on('scroll', function() {
      if ($(window).scrollTop() > 1) {
        $('body').addClass('scrolled');
      }
      else {
        $('body').removeClass('scrolled');
      }
    });

    // SCROLL
    $(document).on('click', 'a[href^="#"].scroll', function (event) {
      event.preventDefault();
      $('body,html').animate({
          scrollTop: $($.attr(this, 'href')).offset().top - 50,
      }, 500);
    });

  },
  finalize() {
    // NAV SELECTOR
    var lastId,
        topMenu = $('.nav'),
        topMenuHeight = topMenu.outerHeight(),
        menuItems = topMenu.find('a:not([rel="nofollow"])'),
        scrollItems = menuItems.map(function(){
          var item = $($(this).attr('href'));
          if (item.length) { return item; }
        });

        menuItems.click(function(e){
          var href = $(this).attr('href'),
              offsetTop = href === '#' ? 0 : $(href).offset().top-topMenuHeight+1;
          $('html, body').stop().animate({
              scrollTop: offsetTop,
          }, 500);
          e.preventDefault();
        });

    // Bind to scroll
    $(window).scroll(function(){
       // Get container scroll position
       var fromTop = $(this).scrollTop()+topMenuHeight;

       // Get id of current scroll item
       var cur = scrollItems.map(function(){
         if ($(this).offset().top < fromTop)
           return this;
       });
       // Get the id of the current element
       cur = cur[cur.length-1];
       var id = cur && cur.length ? cur[0].id : '';

       if (lastId !== id) {
           lastId = id;
           // Set/remove active class
           menuItems
             .parent().removeClass('active')
             /* eslint-disable */
             .end().filter("[href='#"+id+"']").parent().addClass('active');
             /* eslint-enable */
       }
    });

    var $carousel2 = new Flickity('.slider-2', {
      pageDots: false,
      wrapAround: true,
      cellAlign: 'left',
      initialIndex: 0,
      percentPosition: false,
      lazyLoad: true,
      draggable: true,
      freeScroll: false,
      autoPlay: 5000,
      imagesLoaded: true,
      prevNextButtons : true,
    });

    var $carousel3 = new Flickity('.slider-3', {
      pageDots: false,
      wrapAround: true,
      cellAlign: 'left',
      initialIndex: 0,
      percentPosition: false,
      lazyLoad: true,
      draggable: true,
      freeScroll: false,
      autoPlay: 5000,
      imagesLoaded: true,
      prevNextButtons : true,
    });

    var carouselStatus2 = document.querySelector('.carousel-status');
    var carouselStatus3 = document.querySelector('.carousel-status');

    function updateStatus2() {
      var slideNumber = $carousel2.selectedIndex + 1;
      carouselStatus2.textContent = slideNumber + '/' + $carousel2.slides.length;
    }

    function updateStatus3() {
      var slideNumber = $carousel3.selectedIndex + 1;
      carouselStatus3.textContent = slideNumber + '/' + $carousel3.slides.length;
    }

    $carousel2.on( 'select', updateStatus2 );
    $carousel3.on( 'select', updateStatus3 );

    // init Flickity slidingimages
    var $carousel = new Flickity('.slider', {
      pageDots: false,
      wrapAround: true,
      cellAlign: 'left',
      initialIndex: 0,
      percentPosition: false,
      lazyLoad: true,
      draggable: true,
      freeScroll: false,
      autoPlay: 5000,
      imagesLoaded: true,
      prevNextButtons : true,
    });

    var carouselStatus = document.querySelector('.carousel-status');

    function updateStatus() {
      var slideNumber = $carousel.selectedIndex + 1;
      carouselStatus.textContent = slideNumber + '/' + $carousel.slides.length;
    }

    updateStatus();

    $carousel.on( 'select', updateStatus );

    $('#intro').find('.button').on('click', function(){
      var tab = $(this).data('tab');


      $(this).addClass('button--active').siblings().removeClass('button--active');
      $(`div[data-tab='${tab}']`).removeClass('hidden').fadeIn().siblings().fadeOut();
      $carousel.resize();
      $carousel2.resize();
      $carousel3.resize();

      if(tab == 1) {
        updateStatus();
      } else if(tab == 2) {
        updateStatus2();
      } else if(tab == 3) {
        updateStatus3();
      }
    });
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js